/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRecherchecalendrierFormateurDto } from './FcbRecherchecalendrierFormateurDto';
import {
    FcbRecherchecalendrierFormateurDtoFromJSON,
    FcbRecherchecalendrierFormateurDtoFromJSONTyped,
    FcbRecherchecalendrierFormateurDtoToJSON,
} from './FcbRecherchecalendrierFormateurDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRecherchecalendrierFormateurDtoPaginatedResults
 */
export interface FcbRecherchecalendrierFormateurDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRecherchecalendrierFormateurDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRecherchecalendrierFormateurDto>}
     * @memberof FcbRecherchecalendrierFormateurDtoPaginatedResults
     */
    results?: Array<FcbRecherchecalendrierFormateurDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRecherchecalendrierFormateurDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRecherchecalendrierFormateurDtoPaginatedResults interface.
 */
export function instanceOfFcbRecherchecalendrierFormateurDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRecherchecalendrierFormateurDtoPaginatedResultsFromJSON(json: any): FcbRecherchecalendrierFormateurDtoPaginatedResults {
    return FcbRecherchecalendrierFormateurDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRecherchecalendrierFormateurDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRecherchecalendrierFormateurDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRecherchecalendrierFormateurDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRecherchecalendrierFormateurDtoPaginatedResultsToJSON(value?: FcbRecherchecalendrierFormateurDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRecherchecalendrierFormateurDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

